<template>
  <button type="button" class="fab" :aria-label="label" @click="$emit('click')">
    <el-icon :size="24"><Plus /></el-icon>
    <span v-if="label" class="fab-label">{{ label }}</span>
  </button>
</template>

<script>
import { Plus } from '@element-plus/icons-vue'

export default {
  name: 'Fab',
  components: { Plus },
  props: {
    label: { type: String, default: '' }
  },
  emits: ['click']
}
</script>

<style scoped>
/*
 * FAB 는 하단 탭바 **위**에 떠 있어야 한다.
 *
 * 이전 값(bottom 18px + z-overlay 1000)이면 56px 짜리 FAB 가 60px 짜리
 * 하단바 영역으로 42px 내려앉고, z 가 탭바(--z-nav:100)보다 훨씬 높아서
 * 오른쪽 끝 탭('더보기')을 통째로 덮어 누를 수 없게 만든다.
 * --z-fab 토큰이 정확히 이 목적으로 선언돼 있었는데 쓰이지 않고 있었다.
 */
.fab {
  position: fixed;
  right: 18px;
  bottom: calc(var(--nav-bottom-h) + var(--safe-bottom) + 12px);
  z-index: var(--z-fab);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 52px;
  min-width: 52px;
  padding: 0 20px;
  border: none;
  border-radius: var(--r-full);
  background: var(--color-primary);
  color: var(--color-on-accent);
  font-family: inherit;
  box-shadow: var(--sh-primary), var(--sh-2);
  cursor: pointer;
  transition: transform var(--dur) var(--ease), background var(--dur) var(--ease);
}

.fab:active { transform: scale(0.96); background: var(--color-primary-hover); }

.fab-label {
  font-size: var(--fs-md);
  font-weight: var(--fw-semibold);
}

/* 아이콘만 있을 때는 원형 */
.fab:not(:has(.fab-label)) { padding: 0; width: 52px; justify-content: center; }

/* 태블릿 이상에는 하단 탭바가 없다(좌측 SideNav). 화면 끝으로 내린다. */
@media (min-width: 768px) { /* --bp-mobile-max + 1 */
  .fab { bottom: calc(18px + var(--safe-bottom)); }
}
</style>
